import { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle2, Loader2, AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function PaymentSuccessPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying');
  const invoiceId = searchParams.get('invoice_id');

  useEffect(() => {
    if (invoiceId) {
      verifyPayment(invoiceId);
    } else {
      setStatus('error');
    }
  }, [invoiceId]);

  const verifyPayment = async (id) => {
    try {
      const response = await axios.post(`${API_URL}/api/payments/invoice/${id}/verify-payment`);
      if (response.data.status === 'paid' || response.data.status === 'already_paid') {
        setStatus('paid');
      } else if (response.data.status === 'not_paid') {
        setStatus('pending');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center space-y-6">
        {status === 'verifying' && (
          <>
            <Loader2 className="h-16 w-16 animate-spin text-primary mx-auto" />
            <h1 className="font-['Oswald'] text-2xl font-bold uppercase">Zahlung wird geprüft...</h1>
            <p className="text-muted-foreground">Einen Moment bitte.</p>
          </>
        )}
        {status === 'paid' && (
          <>
            <CheckCircle2 className="h-16 w-16 text-green-500 mx-auto" />
            <h1 className="font-['Oswald'] text-2xl font-bold uppercase">Zahlung erfolgreich!</h1>
            <p className="text-muted-foreground">Vielen Dank — deine Rechnung wurde als bezahlt markiert.</p>
          </>
        )}
        {status === 'pending' && (
          <>
            <Loader2 className="h-16 w-16 text-amber-500 mx-auto" />
            <h1 className="font-['Oswald'] text-2xl font-bold uppercase">Zahlung wird verarbeitet</h1>
            <p className="text-muted-foreground">Deine Zahlung wird noch verarbeitet. Die Rechnung wird automatisch aktualisiert.</p>
          </>
        )}
        {status === 'error' && (
          <>
            <AlertCircle className="h-16 w-16 text-red-500 mx-auto" />
            <h1 className="font-['Oswald'] text-2xl font-bold uppercase">Fehler</h1>
            <p className="text-muted-foreground">Die Zahlung konnte nicht verifiziert werden. Bitte kontaktiere uns.</p>
          </>
        )}
        <Link to="/login">
          <Button className="rounded-none mt-4">Zum Mitgliederbereich</Button>
        </Link>
      </div>
    </div>
  );
}
